import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Theme from 'styles/theme';
import Cloudinary from 'utils/Cloudinary';
import CustomPropTypes from 'utils/PropTypes';

const ColorSwatch = class extends Component {
  get background() {
    const { colors, imageUrl, angle } = this.props;

    if (imageUrl) {
      const url = Cloudinary.generateRemoteImageUrl({
        remoteUrl: imageUrl,
        transformations: `q_auto,f_auto,w_${60}`,
      });

      return `url(${url})`;
    }

    const [color1, color2, color3] = colors;

    switch (colors.length) {
      case 1:
        return color1;
      case 2:
        return `linear-gradient(${angle}deg, ${color1} 50%, ${color2} 50%)`;
      case 3:
      default:
        return `linear-gradient(to right, ${color1} 33%, ${color2} 33%, ${color2} 66%, ${color3} 66%)`;
    }
  }

  render() {
    const { diameter, imageUrl } = this.props;

    const ColorSwatchClass = classNames('ColorSwatch', {
      'ColorSwatch--image': imageUrl,
    });

    return (
      <div className={ColorSwatchClass}>
        <style jsx>
          {`
            .ColorSwatch {
              width: ${diameter}px;
              height: ${diameter}px;
              margin: 0 auto;
              border-radius: 50%;
              background: ${this.background};
              position: relative;
              display: inline-block;
              border: solid 1px ${Theme.get('colors-black-20')};
            }

            .ColorSwatch--image.ColorSwatch {
              background-size: cover;
              background-position: center;
            }
          `}
        </style>
      </div>
    );
  }
};

ColorSwatch.propTypes = {
  imageUrl: PropTypes.string,
  colors: CustomPropTypes.colorSwatch, // eslint-disable-line react/require-default-props
  diameter: PropTypes.number.isRequired,
  angle: PropTypes.number,
};

ColorSwatch.defaultProps = {
  angle: 135,
  colors: null,
  diameter: 40,
  imageUrl: null,
};

export default ColorSwatch;
